import { useDefaultEmptyFieldError } from '@/hooks';
import { Col, Form, FormInstance, Input, InputNumber, Row } from 'antd';
import BankAccountInfiniteSelectField from '../../BankAccountInfiniteSelectField';
import DocumentTypesInfiniteSelectField from '../../DocumentTypesInfiniteSelectField';
import FloatingFormItem from '../../FloatingFormItem';
import InputDate from '../../InputDate';
import InputDecimal from '../../InputDecimal';
import { SettleInstallmentSingleFormValues } from './types';
import { hasPermissions } from '@/utils/functions/hasPermissions';
import Authorities from '@/types/Authority';
import CustomStatistic from '../../CustomStatistic';

type Props = {
  form: FormInstance<SettleInstallmentSingleFormValues>;
};

const SettleInstallmentSingleForm: React.FC<Props> = ({ form }) => {
  const requiredRule = useDefaultEmptyFieldError();
  const netValue = Form.useWatch('netValue', form);
  const rateValue = Form.useWatch('rateValue', form);

  const maxNetValue = (netValue || 0) - (rateValue || 0);

  return (
    <Form
      form={form}
      onValuesChange={(_, fields) => {
        form.setFieldValue(
          'netValue',
          (fields.installmentValue || 0) + (fields.discountIncrease || 0),
        );
      }}
    >
      <Form.Item name="rateValue" hidden>
        <InputNumber />
      </Form.Item>
      <Form.Item name="netValue" hidden>
        <InputNumber />
      </Form.Item>
      <Form.Item name="installmentValue" hidden>
        <InputNumber />
      </Form.Item>
      <Form.Item name="id" hidden>
        <Input />
      </Form.Item>
      <Form.Item name="installmentReceivableId" hidden>
        <Input />
      </Form.Item>

      <Row gutter={[12, 12]}>
        <Col span={24}>
          <FloatingFormItem
            name="bankAccountId"
            label="Conta bancária"
            rules={[requiredRule]}
          >
            <BankAccountInfiniteSelectField queryFilter={{ active: true }} />
          </FloatingFormItem>
        </Col>

        <Col span={24}>
          <FloatingFormItem
            name="documentTypeId"
            label="Tipo de Documento"
            rules={[requiredRule]}
          >
            <DocumentTypesInfiniteSelectField
              queryFilter={{ active: true }}
              disabled
            />
          </FloatingFormItem>
        </Col>

        <Col span={24}>
          <FloatingFormItem
            name="payDate"
            label="Data de Pagamento"
            rules={[requiredRule]}
          >
            <InputDate
              disabled={
                !hasPermissions([
                  Authorities.FINANCIAL_ACCOUNT_RECEIVABLE_EDIT_DATE_SETTLE_INSTALLMENT,
                ])
              }
            />
          </FloatingFormItem>
        </Col>

        <Col span={24}>
          <FloatingFormItem
            name="discountIncrease"
            label="Acres./Desc."
            initialValue={0}
          >
            <InputDecimal />
          </FloatingFormItem>
        </Col>

        <Col span={12}>
          <CustomStatistic
            title="Total pago pelo cliente"
            description="totalPagoPeloCliente = valorParcela + descontoAcrescimo"
            value={netValue}
            valueStyle={{ color: '#148e28' }}
          />
        </Col>

        <Col span={12}>
          <CustomStatistic
            title="Líquido a receber"
            description="valorLiquido = (valorParcela + descontoAcrescimo) - tarifas"
            value={maxNetValue}
            valueStyle={{ color: '#4bbacf' }}
          />
        </Col>
      </Row>
    </Form>
  );
};

export default SettleInstallmentSingleForm;
